// extracted by mini-css-extract-plugin
module.exports = {"main-component":"like_main-component__3n2QZ"};